import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-9" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "Subscription", -1)
const _hoisted_5 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_6 = { "aria-label": "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb mb-0" }
const _hoisted_8 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_9 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_10 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_11 = { class: "col-3 text-right" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fa fa-angle-left mr-1" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_14 = { class: "card py-3" }
const _hoisted_15 = { action: "" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { for: "" }, "Package Name", -1)
const _hoisted_18 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_19 = { class: "bg-light border rounded p-3 mb-3" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "card-head pb-3" }, [
  /*#__PURE__*/_createVNode("h1", { class: "card-title" }, "Project")
], -1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { for: "" }, "Project Number", -1)
const _hoisted_25 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_26 = { class: "col-md-3" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { for: "" }, "Channel per project", -1)
const _hoisted_29 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_30 = { class: "col-md-3" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", { for: "" }, "Number of member per channel", -1)
const _hoisted_33 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/_createVNode("label", { for: "" }, "Guest member number", -1)
const _hoisted_37 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { for: "" }, "Number of private channel", -1)
const _hoisted_41 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_42 = { class: "col-md-3" }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = /*#__PURE__*/_createVNode("label", { for: "" }, "Total channel member in system", -1)
const _hoisted_45 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_46 = { class: "col-md-3" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", { for: "" }, "Channel message history (days)", -1)
const _hoisted_49 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_50 = { class: "col-md-3" }
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = /*#__PURE__*/_createVNode("label", { for: "" }, "Channel file size (GB) ", -1)
const _hoisted_53 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_54 = { class: "col-md-3" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = /*#__PURE__*/_createVNode("label", { for: "" }, "Export channel as PDF ", -1)
const _hoisted_57 = { class: "d-block" }
const _hoisted_58 = { class: "form-check form-check-inline" }
const _hoisted_59 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineRadio1"
}, "Yes", -1)
const _hoisted_60 = { class: "form-check form-check-inline" }
const _hoisted_61 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineRadio2"
}, "No", -1)
const _hoisted_62 = { class: "col-md-3" }
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = /*#__PURE__*/_createVNode("label", { for: "" }, "Archive channel ", -1)
const _hoisted_65 = { class: "d-block" }
const _hoisted_66 = { class: "form-check form-check-inline" }
const _hoisted_67 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineRadio3"
}, "Yes", -1)
const _hoisted_68 = { class: "form-check form-check-inline" }
const _hoisted_69 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineRadio4"
}, "No", -1)
const _hoisted_70 = { class: "col-md-3" }
const _hoisted_71 = { class: "form-group" }
const _hoisted_72 = /*#__PURE__*/_createVNode("label", { for: "" }, "Estimation per project ", -1)
const _hoisted_73 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_74 = { class: "col-md-3" }
const _hoisted_75 = { class: "form-group" }
const _hoisted_76 = /*#__PURE__*/_createVNode("label", { for: "" }, "Budget of total estimation(USD) ", -1)
const _hoisted_77 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_78 = { class: "col-md-3" }
const _hoisted_79 = { class: "form-group" }
const _hoisted_80 = /*#__PURE__*/_createVNode("label", { for: "" }, "Phase per smartcontract ", -1)
const _hoisted_81 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_82 = { class: "col-md-3" }
const _hoisted_83 = { class: "form-group" }
const _hoisted_84 = /*#__PURE__*/_createVNode("label", { for: "" }, "Total task per phase ", -1)
const _hoisted_85 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_86 = { class: "col-md-3" }
const _hoisted_87 = { class: "form-group" }
const _hoisted_88 = /*#__PURE__*/_createVNode("label", { for: "" }, "Total member in smart contract ", -1)
const _hoisted_89 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_90 = { class: "col-md-3" }
const _hoisted_91 = { class: "form-group" }
const _hoisted_92 = /*#__PURE__*/_createVNode("label", { for: "" }, "Payment of invoices ", -1)
const _hoisted_93 = { class: "d-block" }
const _hoisted_94 = { class: "form-check form-check-inline" }
const _hoisted_95 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineRadio5"
}, "Yes", -1)
const _hoisted_96 = { class: "form-check form-check-inline" }
const _hoisted_97 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineRadio6"
}, "No", -1)
const _hoisted_98 = { class: "row" }
const _hoisted_99 = { class: "col-md-6" }
const _hoisted_100 = { class: "bg-light border rounded p-3 mb-3" }
const _hoisted_101 = /*#__PURE__*/_createVNode("div", { class: "card-head pb-3" }, [
  /*#__PURE__*/_createVNode("h1", { class: "card-title" }, "My Templates")
], -1)
const _hoisted_102 = { class: "row" }
const _hoisted_103 = { class: "col-md-6" }
const _hoisted_104 = { class: "form-group" }
const _hoisted_105 = /*#__PURE__*/_createVNode("label", { for: "" }, "Number of templates", -1)
const _hoisted_106 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_107 = { class: "col-md-6" }
const _hoisted_108 = { class: "form-group" }
const _hoisted_109 = /*#__PURE__*/_createVNode("label", { for: "" }, "Number of PDF", -1)
const _hoisted_110 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_111 = { class: "col-md-6" }
const _hoisted_112 = { class: "form-group" }
const _hoisted_113 = /*#__PURE__*/_createVNode("label", { for: "" }, "Number of folder", -1)
const _hoisted_114 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_115 = { class: "col-md-6" }
const _hoisted_116 = { class: "form-group" }
const _hoisted_117 = /*#__PURE__*/_createVNode("label", { for: "" }, "Number of files", -1)
const _hoisted_118 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_119 = { class: "col-md-6" }
const _hoisted_120 = { class: "bg-light border rounded p-3 mb-3" }
const _hoisted_121 = /*#__PURE__*/_createVNode("div", { class: "card-head pb-3" }, [
  /*#__PURE__*/_createVNode("h1", { class: "card-title" }, "My Calender")
], -1)
const _hoisted_122 = { class: "form-group" }
const _hoisted_123 = /*#__PURE__*/_createVNode("label", { for: "" }, "Number of appointment", -1)
const _hoisted_124 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_125 = { class: "form-group" }
const _hoisted_126 = /*#__PURE__*/_createVNode("label", { for: "" }, "Number member of appointment", -1)
const _hoisted_127 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_128 = { class: "bg-light border rounded p-3 mb-3" }
const _hoisted_129 = /*#__PURE__*/_createVNode("div", { class: "card-head pb-3" }, [
  /*#__PURE__*/_createVNode("h1", { class: "card-title" }, "My Calender")
], -1)
const _hoisted_130 = { class: "row" }
const _hoisted_131 = { class: "col-md-6" }
const _hoisted_132 = { class: "form-group" }
const _hoisted_133 = /*#__PURE__*/_createVNode("label", { for: "" }, "Import options", -1)
const _hoisted_134 = { class: "d-block" }
const _hoisted_135 = { class: "form-check form-check-inline" }
const _hoisted_136 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineRadio7"
}, "Google", -1)
const _hoisted_137 = { class: "form-check form-check-inline" }
const _hoisted_138 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineRadio8"
}, "Yahoo", -1)
const _hoisted_139 = { class: "form-check form-check-inline" }
const _hoisted_140 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineRadio9"
}, "Outlook", -1)
const _hoisted_141 = { class: "form-check form-check-inline" }
const _hoisted_142 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineRadio9"
}, "Icloud", -1)
const _hoisted_143 = { class: "col-md-6" }
const _hoisted_144 = { class: "form-group" }
const _hoisted_145 = /*#__PURE__*/_createVNode("label", { for: "" }, "Sync options", -1)
const _hoisted_146 = { class: "d-block" }
const _hoisted_147 = { class: "form-check form-check-inline" }
const _hoisted_148 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineRadio10"
}, "Allow", -1)
const _hoisted_149 = { class: "form-check form-check-inline" }
const _hoisted_150 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineRadio11"
}, "Don't Allow", -1)
const _hoisted_151 = { class: "col-md-6" }
const _hoisted_152 = { class: "form-group" }
const _hoisted_153 = /*#__PURE__*/_createVNode("label", { for: "" }, "Amount", -1)
const _hoisted_154 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_155 = { class: "col-md-6" }
const _hoisted_156 = { class: "form-group" }
const _hoisted_157 = /*#__PURE__*/_createVNode("label", { for: "" }, "Time duration (days)", -1)
const _hoisted_158 = {
  key: 0,
  class: "text-danger d-block mt-2"
}
const _hoisted_159 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode("nav", _hoisted_6, [
              _createVNode("ol", _hoisted_7, [
                _hoisted_8,
                _createVNode("li", _hoisted_9, [
                  _createVNode("a", _hoisted_10, _toDisplayString(_ctx.state.data.editMode ? "Edit Subscription" : "Create Subscription"), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_router_link, {
            to: { name: 'admin-subscription' },
            class: "btn default-btn"
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              _hoisted_13
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode(_component_ErrorList, {
        errors: _ctx.state.ui.error.errorList.subscription,
        hasError: _ctx.state.ui.error.hasError
      }, null, 8, ["errors", "hasError"]),
      _createVNode("form", _hoisted_15, [
        _createVNode("div", _hoisted_16, [
          _hoisted_17,
          _withDirectives(_createVNode("input", {
            type: "text",
            class: _ctx.validation.packageName.required ? 'form-control error-field' : 'form-control',
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.subscription.packageName = $event)),
            disabled: _ctx.state.data.editMode,
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearValidation('packageName')))
          }, null, 42, ["disabled"]), [
            [_vModelText, _ctx.state.data.subscription.packageName]
          ]),
          (_ctx.validation.packageName.required)
            ? (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(_ctx.validation.packageName.message), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  class: _ctx.validation.projectNumber.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.subscription.project.projectNumber = $event)),
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearValidation('projectNumber')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.project.projectNumber]
                ]),
                (_ctx.validation.projectNumber.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_25, _toDisplayString(_ctx.validation.projectNumber.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _hoisted_28,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  class: _ctx.validation.channelPerProject.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.subscription.project.channelPerProject = $event)),
                  onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearValidation('channelPerProject')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.project.channelPerProject]
                ]),
                (_ctx.validation.channelPerProject.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(_ctx.validation.channelPerProject.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                _hoisted_32,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  class: _ctx.validation.memberPerChannel.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.subscription.project.memberPerChannel = $event)),
                  onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clearValidation('memberPerChannel')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.project.memberPerChannel]
                ]),
                (_ctx.validation.memberPerChannel.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_33, _toDisplayString(_ctx.validation.memberPerChannel.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_34, [
              _createVNode("div", _hoisted_35, [
                _hoisted_36,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: _ctx.validation.guestMember.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.subscription.project.guestMember = $event)),
                  onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.clearValidation('guestMember')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.project.guestMember]
                ]),
                (_ctx.validation.guestMember.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_37, _toDisplayString(_ctx.validation.guestMember.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_38, [
              _createVNode("div", _hoisted_39, [
                _hoisted_40,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: _ctx.validation.privateChannel.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.data.subscription.project.privateChannel = $event)),
                  onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.clearValidation('privateChannel')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.project.privateChannel]
                ]),
                (_ctx.validation.privateChannel.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(_ctx.validation.privateChannel.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _hoisted_44,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: _ctx.validation.totalChannelMember.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.state.data.subscription.project.totalChannelMember = $event)),
                  onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.clearValidation('totalChannelMember')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.project.totalChannelMember]
                ]),
                (_ctx.validation.totalChannelMember.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_45, _toDisplayString(_ctx.validation.totalChannelMember.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_46, [
              _createVNode("div", _hoisted_47, [
                _hoisted_48,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: _ctx.validation.channelMessageHistory.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.state.data.subscription.project.channelMessageHistory = $event)),
                  onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.clearValidation('channelMessageHistory')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.project.channelMessageHistory]
                ]),
                (_ctx.validation.channelMessageHistory.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_49, _toDisplayString(_ctx.validation.channelMessageHistory.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_50, [
              _createVNode("div", _hoisted_51, [
                _hoisted_52,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: _ctx.validation.ChannelFileSize.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.data.subscription.project.ChannelFileSize = $event)),
                  onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.clearValidation('ChannelFileSize')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.project.ChannelFileSize]
                ]),
                (_ctx.validation.ChannelFileSize.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_53, _toDisplayString(_ctx.validation.ChannelFileSize.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_54, [
              _createVNode("div", _hoisted_55, [
                _hoisted_56,
                _createVNode("div", _hoisted_57, [
                  _createVNode("div", _hoisted_58, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "inlineRadioOptions",
                      id: "inlineRadio1",
                      value: "1",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.state.data.subscription.project.exportChannelPdf = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.state.data.subscription.project.exportChannelPdf]
                    ]),
                    _hoisted_59
                  ]),
                  _createVNode("div", _hoisted_60, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "inlineRadioOptions",
                      id: "inlineRadio2",
                      value: "0",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.state.data.subscription.project.exportChannelPdf = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.state.data.subscription.project.exportChannelPdf]
                    ]),
                    _hoisted_61
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_62, [
              _createVNode("div", _hoisted_63, [
                _hoisted_64,
                _createVNode("div", _hoisted_65, [
                  _createVNode("div", _hoisted_66, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.state.data.subscription.project.archiveChannel = $event)),
                      type: "radio",
                      name: "inlineRadioOptions1",
                      id: "inlineRadio3",
                      value: "1"
                    }, null, 512), [
                      [_vModelRadio, _ctx.state.data.subscription.project.archiveChannel]
                    ]),
                    _hoisted_67
                  ]),
                  _createVNode("div", _hoisted_68, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.state.data.subscription.project.archiveChannel = $event)),
                      type: "radio",
                      name: "inlineRadioOptions1",
                      id: "inlineRadio4",
                      value: "0"
                    }, null, 512), [
                      [_vModelRadio, _ctx.state.data.subscription.project.archiveChannel]
                    ]),
                    _hoisted_69
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_70, [
              _createVNode("div", _hoisted_71, [
                _hoisted_72,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  class: _ctx.validation.estimationPerProject.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.state.data.subscription.project.estimationPerProject = $event)),
                  onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.clearValidation('estimationPerProject')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.project.estimationPerProject]
                ]),
                (_ctx.validation.estimationPerProject.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_73, _toDisplayString(_ctx.validation.estimationPerProject.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_74, [
              _createVNode("div", _hoisted_75, [
                _hoisted_76,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  class: _ctx.validation.totalEstimation.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.state.data.subscription.project.totalEstimation = $event)),
                  onInput: _cache[26] || (_cache[26] = ($event: any) => (_ctx.clearValidation('totalEstimation')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.project.totalEstimation]
                ]),
                (_ctx.validation.totalEstimation.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_77, _toDisplayString(_ctx.validation.totalEstimation.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_78, [
              _createVNode("div", _hoisted_79, [
                _hoisted_80,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: _ctx.validation.phasePerSmartContract.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.state.data.subscription.project.phasePerSmartContract = $event)),
                  onInput: _cache[28] || (_cache[28] = ($event: any) => (_ctx.clearValidation('phasePerSmartContract')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.project.phasePerSmartContract]
                ]),
                (_ctx.validation.phasePerSmartContract.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_81, _toDisplayString(_ctx.validation.phasePerSmartContract.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_82, [
              _createVNode("div", _hoisted_83, [
                _hoisted_84,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  class: _ctx.validation.taskPerPhase.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.state.data.subscription.project.taskPerPhase = $event)),
                  onInput: _cache[30] || (_cache[30] = ($event: any) => (_ctx.clearValidation('taskPerPhase')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.project.taskPerPhase]
                ]),
                (_ctx.validation.taskPerPhase.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_85, _toDisplayString(_ctx.validation.taskPerPhase.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_86, [
              _createVNode("div", _hoisted_87, [
                _hoisted_88,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  class: _ctx.validation.memberinSmartContract.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.state.data.subscription.project.memberinSmartContract = $event)),
                  onInput: _cache[32] || (_cache[32] = ($event: any) => (_ctx.clearValidation('memberinSmartContract')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.project.memberinSmartContract]
                ]),
                (_ctx.validation.memberinSmartContract.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_89, _toDisplayString(_ctx.validation.memberinSmartContract.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_90, [
              _createVNode("div", _hoisted_91, [
                _hoisted_92,
                _createVNode("div", _hoisted_93, [
                  _createVNode("div", _hoisted_94, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.state.data.subscription.project.invoicePayment = $event)),
                      class: "form-check-input",
                      type: "radio",
                      name: "inlineRadioOptions3",
                      id: "inlineRadio5",
                      value: "1"
                    }, null, 512), [
                      [_vModelRadio, _ctx.state.data.subscription.project.invoicePayment]
                    ]),
                    _hoisted_95
                  ]),
                  _createVNode("div", _hoisted_96, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.state.data.subscription.project.invoicePayment = $event)),
                      class: "form-check-input",
                      type: "radio",
                      name: "inlineRadioOptions3",
                      id: "inlineRadio6",
                      value: "0"
                    }, null, 512), [
                      [_vModelRadio, _ctx.state.data.subscription.project.invoicePayment]
                    ]),
                    _hoisted_97
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_98, [
          _createVNode("div", _hoisted_99, [
            _createVNode("div", _hoisted_100, [
              _hoisted_101,
              _createVNode("div", _hoisted_102, [
                _createVNode("div", _hoisted_103, [
                  _createVNode("div", _hoisted_104, [
                    _hoisted_105,
                    _withDirectives(_createVNode("input", {
                      type: "number",
                      class: _ctx.validation.templateNumber.required ? 'form-control error-field' : 'form-control',
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.state.data.subscription.template.templateNumber = $event)),
                      onInput: _cache[36] || (_cache[36] = ($event: any) => (_ctx.clearValidation('templateNumber')))
                    }, null, 34), [
                      [_vModelText, _ctx.state.data.subscription.template.templateNumber]
                    ]),
                    (_ctx.validation.templateNumber.required)
                      ? (_openBlock(), _createBlock("span", _hoisted_106, _toDisplayString(_ctx.validation.templateNumber.message), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_107, [
                  _createVNode("div", _hoisted_108, [
                    _hoisted_109,
                    _withDirectives(_createVNode("input", {
                      type: "number",
                      class: _ctx.validation.pdfNumber.required ? 'form-control error-field' : 'form-control',
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.state.data.subscription.template.pdfNumber = $event)),
                      onInput: _cache[38] || (_cache[38] = ($event: any) => (_ctx.clearValidation('pdfNumber')))
                    }, null, 34), [
                      [_vModelText, _ctx.state.data.subscription.template.pdfNumber]
                    ]),
                    (_ctx.validation.pdfNumber.required)
                      ? (_openBlock(), _createBlock("span", _hoisted_110, _toDisplayString(_ctx.validation.pdfNumber.message), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_111, [
                  _createVNode("div", _hoisted_112, [
                    _hoisted_113,
                    _withDirectives(_createVNode("input", {
                      type: "number",
                      class: _ctx.validation.folderNumber.required ? 'form-control error-field' : 'form-control',
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.state.data.subscription.template.folderNumber = $event)),
                      onInput: _cache[40] || (_cache[40] = ($event: any) => (_ctx.clearValidation('folderNumber')))
                    }, null, 34), [
                      [_vModelText, _ctx.state.data.subscription.template.folderNumber]
                    ]),
                    (_ctx.validation.folderNumber.required)
                      ? (_openBlock(), _createBlock("span", _hoisted_114, _toDisplayString(_ctx.validation.folderNumber.message), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_115, [
                  _createVNode("div", _hoisted_116, [
                    _hoisted_117,
                    _withDirectives(_createVNode("input", {
                      type: "number",
                      class: _ctx.validation.filesNumber.required ? 'form-control error-field' : 'form-control',
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.state.data.subscription.template.filesNumber = $event)),
                      onInput: _cache[42] || (_cache[42] = ($event: any) => (_ctx.clearValidation('filesNumber')))
                    }, null, 34), [
                      [_vModelText, _ctx.state.data.subscription.template.filesNumber]
                    ]),
                    (_ctx.validation.filesNumber.required)
                      ? (_openBlock(), _createBlock("span", _hoisted_118, _toDisplayString(_ctx.validation.filesNumber.message), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_119, [
            _createVNode("div", _hoisted_120, [
              _hoisted_121,
              _createVNode("div", _hoisted_122, [
                _hoisted_123,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  class: _ctx.validation.appointmentNumbers.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.state.data.subscription.mycalender.appointmentNumbers = $event)),
                  onInput: _cache[44] || (_cache[44] = ($event: any) => (_ctx.clearValidation('appointmentNumbers')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.mycalender.appointmentNumbers]
                ]),
                (_ctx.validation.appointmentNumbers.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_124, _toDisplayString(_ctx.validation.appointmentNumbers.message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_125, [
                _hoisted_126,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  class: _ctx.validation.membersPerAppointment.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.state.data.subscription.mycalender.membersPerAppointment = $event)),
                  onInput: _cache[46] || (_cache[46] = ($event: any) => (_ctx.clearValidation('membersPerAppointment')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.mycalender.membersPerAppointment]
                ]),
                (_ctx.validation.membersPerAppointment.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_127, _toDisplayString(_ctx.validation.membersPerAppointment.message), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_128, [
          _hoisted_129,
          _createVNode("div", _hoisted_130, [
            _createVNode("div", _hoisted_131, [
              _createVNode("div", _hoisted_132, [
                _hoisted_133,
                _createVNode("div", _hoisted_134, [
                  _createVNode("div", _hoisted_135, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "inlineRadioOptions4",
                      id: "inlineRadio7",
                      value: "google",
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.state.data.subscription.mycalender.importOption = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.state.data.subscription.mycalender.importOption]
                    ]),
                    _hoisted_136
                  ]),
                  _createVNode("div", _hoisted_137, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "inlineRadioOptions4",
                      id: "inlineRadio8",
                      value: "yahoo",
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.state.data.subscription.mycalender.importOption = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.state.data.subscription.mycalender.importOption]
                    ]),
                    _hoisted_138
                  ]),
                  _createVNode("div", _hoisted_139, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "inlineRadioOptions4",
                      id: "inlineRadio9",
                      value: "outlook",
                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.state.data.subscription.mycalender.importOption = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.state.data.subscription.mycalender.importOption]
                    ]),
                    _hoisted_140
                  ]),
                  _createVNode("div", _hoisted_141, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "inlineRadioOptions4",
                      id: "inlineRadio9",
                      value: "icloud",
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.state.data.subscription.mycalender.importOption = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.state.data.subscription.mycalender.importOption]
                    ]),
                    _hoisted_142
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_143, [
              _createVNode("div", _hoisted_144, [
                _hoisted_145,
                _createVNode("div", _hoisted_146, [
                  _createVNode("div", _hoisted_147, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "inlineRadioOptions5",
                      id: "inlineRadio10",
                      value: "1",
                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.state.data.subscription.mycalender.syncOption = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.state.data.subscription.mycalender.syncOption]
                    ]),
                    _hoisted_148
                  ]),
                  _createVNode("div", _hoisted_149, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "inlineRadioOptions5",
                      id: "inlineRadio11",
                      value: "0",
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.state.data.subscription.mycalender.syncOption = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.state.data.subscription.mycalender.syncOption]
                    ]),
                    _hoisted_150
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_151, [
              _createVNode("div", _hoisted_152, [
                _hoisted_153,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  class: _ctx.validation.amount.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (_ctx.state.data.subscription.mycalender.amount = $event)),
                  onInput: _cache[54] || (_cache[54] = ($event: any) => (_ctx.clearValidation('amount')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.mycalender.amount]
                ]),
                (_ctx.validation.amount.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_154, _toDisplayString(_ctx.validation.amount.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_155, [
              _createVNode("div", _hoisted_156, [
                _hoisted_157,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  class: _ctx.validation.timeDuration.required ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (_ctx.state.data.subscription.mycalender.timeDuration = $event)),
                  onInput: _cache[56] || (_cache[56] = ($event: any) => (_ctx.clearValidation('timeDuration')))
                }, null, 34), [
                  [_vModelText, _ctx.state.data.subscription.mycalender.timeDuration]
                ]),
                (_ctx.validation.timeDuration.required)
                  ? (_openBlock(), _createBlock("span", _hoisted_158, _toDisplayString(_ctx.validation.timeDuration.message), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_159, [
          _createVNode("button", {
            type: "button",
            class: "btn default-btn",
            onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.saveAction && _ctx.saveAction(...args))),
            disabled: _ctx.state.ui.isPostLoading.createSubscription
          }, _toDisplayString(_ctx.state.ui.isPostLoading.createSubscription ?
            "Loading" : 'Submit'), 9, ["disabled"]),
          _createVNode("button", {
            type: "submit",
            class: "btn secondary-btn py-2 ml-2",
            onClick: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.resetSubscription && _ctx.resetSubscription(...args)))
          }, " Cancel ")
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ]))
}